import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';
import { UnsavedChangesModalComponent } from '@organisms/unsaved-changes-modal/unsaved-changes-modal.component';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
export interface HasUnsavedChanges {
  hasChanges: boolean;
}

export const pendingChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
  if (!component.hasChanges) {
    return true;
  }
  const dialog = inject(MatDialog);
  const dialogRef = dialog.open(UnsavedChangesModalComponent, {
    width: '900px',
    disableClose: true,
    panelClass: 'unsaved-changes-modal-panel'
  });

  return dialogRef.afterClosed().pipe(switchMap((leave: boolean) => of(!!leave)));
};
